import * as types from "./casualContractActionType";

const initialState = {
    vehicleList: [],
}
const CasualContractReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.VEHICLE_LIST:
            return {
                ...state,
                vehicleList: [...action.payload]
            }
        default:
            return state;
    }
}
export default CasualContractReducer;